import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/tx.jpg'
import _imports_1 from '@/assets/img/new/user_collect.png'
import _imports_2 from '@/assets/img/new/user_take.png'


const _withScopeId = n => (_pushScopeId("data-v-c7ae96ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user_page" }
const _hoisted_2 = { class: "user_box" }
const _hoisted_3 = { class: "user_info" }
const _hoisted_4 = { class: "info_name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info_ava" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-fenpei" }, null, -1))
const _hoisted_7 = { class: "other_info" }
const _hoisted_8 = { class: "other_item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "姓名:", -1))
const _hoisted_10 = { class: "other_item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电话:", -1))
const _hoisted_12 = { class: "other_item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "学校:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-right" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-right" }, null, -1))

import { onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const router = useRouter();
const person: any = reactive ({
    userInfo: {}
})

onMounted(() => {
    // 判断是主页，头部不加背景色
    if (router.currentRoute.value.name !== 'teaIndex') {
        store.commit('setIsBg',false)
    }
    // 获取当前用户信息
    person.userInfo = JSON.parse(JSON.parse(JSON.stringify(window.localStorage.getItem("userinfo"))));
})

// 跳转我的收藏
const toCollect=()=>{
    router.push({name:'myCollect'})
}
// 跳转学习记录
const toLearn=()=>{
    router.push({name:'learnTake'})
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(person.userInfo.Account), 1),
            _hoisted_6
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(_toDisplayString(person.userInfo.Name ? person.userInfo.Name :'无'), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(_toDisplayString(person.userInfo.Mobile ? person.userInfo.Mobile:'无'), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(_toDisplayString(person.userInfo.SchoolName ? person.userInfo.SchoolName :'无'), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", { class: "home_box" }, [
      _createElementVNode("div", { class: "collect_box" }, [
        _createElementVNode("div", {
          class: "collect_btn",
          onClick: toCollect
        }, [
          _hoisted_14,
          _createTextVNode(" 我的收藏 "),
          _hoisted_15
        ]),
        _createElementVNode("div", {
          class: "collect_btn seach_learn",
          onClick: toLearn
        }, [
          _hoisted_16,
          _createTextVNode(" 学习记录 "),
          _hoisted_17
        ])
      ])
    ])
  ]))
}
}

})